var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-menu"},_vm._l((_vm.navChoicesModel),function(navChoice,index){return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],key:index,staticClass:"component",class:{
      active: navChoice.active,
      left: index === 0,
      right: index === _vm.navChoicesModel.length - 1,
      'read-only': _vm.readOnly,
    },style:('width : ' + 100 / _vm.navChoicesModel.length + '%'),attrs:{"title":`${navChoice.name || navChoice.link}`},on:{"click":function($event){return _vm.setNavChoice(index)}}},[_c('i',{class:navChoice.icon})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }